/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * desakita API — permukaan publik
 * Dokumen TURUNAN — JANGAN diedit. Dihasilkan scripts/gen-public-spec.ts dari dist/openapi.bundled.yaml, memuat HANYA operasi ber-`security: []`. Untuk mengubah isinya, ubah kontraknya (openapi/features/*.yaml) lalu daftarkan operationId-nya di openapi/_shared/public-operations.yaml.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FailureResponse,
  GetOrganizationRoutingTypesParams,
  OrganizationPublicDetailResponse,
  OrganizationRoutingTypesResponse,
  SuccessEnvelope
} from '../../model';

import { publicFetch } from '../../../mutator/publicFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetOrganizationRoutingTypesUrl = (params?: GetOrganizationRoutingTypesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organization/routing/types?${stringifiedParams}` : `/organization/routing/types`
}

export const getOrganizationRoutingTypes = async (params?: GetOrganizationRoutingTypesParams, options?: RequestInit): Promise<SuccessEnvelope & OrganizationRoutingTypesResponse> => {

  return publicFetch<SuccessEnvelope & OrganizationRoutingTypesResponse>(getGetOrganizationRoutingTypesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationRoutingTypesQueryKey = (params?: GetOrganizationRoutingTypesParams,) => {
    return [
    `/organization/routing/types`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganizationRoutingTypesQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError = FailureResponse>(params?: GetOrganizationRoutingTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationRoutingTypesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationRoutingTypes>>> = ({ signal }) => getOrganizationRoutingTypes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationRoutingTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationRoutingTypes>>>
export type GetOrganizationRoutingTypesQueryError = FailureResponse


export function useGetOrganizationRoutingTypes<TData = Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError = FailureResponse>(
 params: undefined |  GetOrganizationRoutingTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRoutingTypes>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRoutingTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoutingTypes<TData = Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError = FailureResponse>(
 params?: GetOrganizationRoutingTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRoutingTypes>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRoutingTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRoutingTypes<TData = Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError = FailureResponse>(
 params?: GetOrganizationRoutingTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganizationRoutingTypes<TData = Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError = FailureResponse>(
 params?: GetOrganizationRoutingTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRoutingTypes>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationRoutingTypesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPublicOrganizationDetailUrl = () => {




  return `/public/organization/detail`
}

export const getPublicOrganizationDetail = async ( options?: RequestInit): Promise<SuccessEnvelope & OrganizationPublicDetailResponse> => {

  return publicFetch<SuccessEnvelope & OrganizationPublicDetailResponse>(getGetPublicOrganizationDetailUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicOrganizationDetailQueryKey = () => {
    return [
    `/public/organization/detail`
    ] as const;
    }


export const getGetPublicOrganizationDetailQueryOptions = <TData = Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicOrganizationDetailQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicOrganizationDetail>>> = ({ signal }) => getPublicOrganizationDetail({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicOrganizationDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicOrganizationDetail>>>
export type GetPublicOrganizationDetailQueryError = FailureResponse


export function useGetPublicOrganizationDetail<TData = Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicOrganizationDetail>>,
          TError,
          Awaited<ReturnType<typeof getPublicOrganizationDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicOrganizationDetail<TData = Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicOrganizationDetail>>,
          TError,
          Awaited<ReturnType<typeof getPublicOrganizationDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicOrganizationDetail<TData = Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicOrganizationDetail<TData = Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicOrganizationDetail>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicOrganizationDetailQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






